import { alpha, Box, Button, buttonClasses } from '@mui/material';
import React, { FC } from 'react';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import ActionsButton from 'src/components/ActionsButton';

const HeaderContent: FC = () => {
  return (
    <Box display="flex" flexWrap="nowrap" alignItems="center" gap={1}>
      <Button
        variant="outlined"
        startIcon={
          <AddOutlinedIcon
            color="inherit"
            sx={{ fontSize: '16px !important' }}
          />
        }
        sx={{
          color: 'primary.main.dark',
          pr: ({ spacing }) => spacing(1),
          py: ({ spacing }) => spacing(0.5),
          fontWeight: 600,
          fontSize: 12,
          // color: 'inherit',
          borderRadius: 22,
          background: ({ palette }) =>
            alpha(palette.primaryLight80 ?? '', 0.25),
          [`& .${buttonClasses.startIcon}`]: {
            margin: 0,
            marginInlineEnd: 0.5,
          },
        }}
      >
        הוסף תיבת דואר
      </Button>
      {/* <ActionsButton label="פעולות" /> */}
    </Box>
  );
};

export default HeaderContent;
